import { PageData } from '@/types';

export const CfgStore: PageData = {
  tabCfg: [],
  bannerCfg: [],
  organCfg: [],
  projectData: [], // 所有在线的项目
  allProjectData: [], // 所有项目，包括下线的项目
};
